import { permanentRedirect, redirect } from 'next/navigation';

/**
 * Relative paths stay on the current request host (e.g. localhost during local dev).
 * Absolute URLs are passed through unchanged.
 */
const resolveRedirectTarget = (url: string) => {
    if (/^https?:\/\//i.test(url)) {
        return url;
    }

    return url.startsWith('/') ? url : `/${url}`;
};

/**
 * Redirects to a PetSmart URL with a 308 permanent redirect.
 *
 * @param url - The target URL path (relative) or full URL (absolute)
 * @returns Never returns - triggers a 308 permanent redirect
 *
 * @example
 * ```typescript
 * // Stays on the current host, e.g. https://www.petsmart.com/dog
 * internalPermanentDirect('/dog');
 *
 * // Absolute Algolia redirect URLs are unchanged
 * internalPermanentDirect('https://www.petsmart.com/search?q=treats');
 * ```
 */
export const internalPermanentDirect = (url: string) => {
    permanentRedirect(resolveRedirectTarget(url));
};

/**
 * Redirects with a 307 temporary redirect.
 *
 * @param url - The target URL path (relative) or full URL (absolute)
 * @returns Never returns - triggers a 307 temporary redirect
 *
 * @example
 * ```typescript
 * internalTemporaryRedirect('/dog/food/f/brand/authority');
 * ```
 */
export const internalTemporaryRedirect = (url: string) => {
    redirect(resolveRedirectTarget(url));
};
